import { Modal } from "bootstrap";
import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

const B2BAssignModal = forwardRef((props, ref) => {

    const { selectedLeads, setSelectedLeads, getLeadData } = props;

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });

    const modalRef = useRef(null);
    const bsModal = useRef(null);
    const leadIdRef = useRef(null);

    // STATES
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [loadData, setLoadData] = useState({});
    const [loadPercentage, setLoadPercentage] = useState({});
    const [loader, setLoader] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);

    // RESET + CLOSE
    const handleClose = () => {
        reset();
        setSelectedEmployee(null);
        setLoadData({});
        setLoadPercentage({});
        bsModal.current?.hide();
    };

    // MODAL HANDLE
    useImperativeHandle(ref, () => ({
        toggle(leadId) {

            leadIdRef.current = leadId;

            if (!bsModal.current) {
                bsModal.current = new Modal(modalRef.current);
            }

            bsModal.current.show();
            getEmployeeData();
        },

        close() {
            handleClose();
        },
    }));

    // GET EMPLOYEES
    const getEmployeeData = () => {
        b2bleadService.getEmployees()
            .then((res) => {
                if (res?.data?.status === "success") {
                    const employeeOptions = res?.data?.data?.map((item) => ({
                        label: `${item.firstName} ${item.lastName}`,
                        value: item.id,
                    }));
                    setEmployees(employeeOptions);
                }
            })
            .catch((err) => {
                console.log("EMPLOYEE ERROR", err);
            });
    };

    // EMPLOYEE LOAD
    // const getEmployeeLoad = (empId) => {
    //     setLoader(true);

    //     b2cleadService.getEmployeeLeadLoad(empId)
    //         .then((res) => {
    //             if (res?.data?.status === "success") {
    //                 // setLoadData(res?.data?.data);
    //                 setLoadData({
    //                     ...res?.data?.data,
    //                     pendingPercentage:
    //                         res?.data?.data?.pendingPercentage,
    //                 });
    //                 setLoadPercentage(res?.data?.data?.employee);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log("LOAD ERROR", err);
    //         })
    //         .finally(() => {
    //             setLoader(false);
    //         });
    // };

    const getEmployeeLoad = (empId) => {

    setLoader(true);

    b2bleadService
        .getEmployeeLeadLoad(empId)

        .then((res) => {

            console.log(
                "LOAD RESPONSE",
                res?.data
            );

            const responseData =
                res?.data?.data || {};

            setLoadData({
                pendingPercentage:
                    responseData?.pendingPercentage || 0,

                totalLead:
                    responseData?.totalLead || 0,

                totalPendingLead:
                    responseData?.totalPendingLead || 0,
            });

            setLoadPercentage(
                responseData?.employee || {}
            );

        })

        .catch((err) => {

            console.log(
                "LOAD ERROR",
                err
            );

        })

        .finally(() => {

            setLoader(false);

        });
};


    const onSubmit = async (data) => {

        setSubmitLoader(true);

        const empId = data?.employee?.value;
        const leadId = leadIdRef.current;

        try {

            const formData = new FormData();
            formData.append("empId", empId);
            // formData.append("assignType", "B2B");
            await b2bleadService.assignLead(leadId, formData);

            toast.success("Lead assigned successfully");

            handleClose();
            getLeadData();

        } catch (error) {

            console.log("ASSIGN ERROR", error);
            toast.error("Failed To Assign Lead");

        } finally {
            setSubmitLoader(false);
        }
    };

    return (
        <div
            className="modal fade"
            ref={modalRef}
            tabIndex="-1"
            aria-hidden="true"
            style={{
                background: "rgba(15,23,42,0.55)",
                backdropFilter: "blur(5px)",
            }}
        >

            <div className="modal-dialog modal-lg modal-dialog-centered">

                <div className="modal-content border-0 rounded-4 overflow-hidden">

                    {/* HEADER */}
                    <div
                        className="modal-header border-0 text-white"
                        style={{
                            background: "rgb(94, 44, 158)",
                        }}
                    >

                        <div>
                            <p className="mb-0 small opacity-75">
                                Assign selected leads to employee
                            </p>
                        </div>

                        <button
                            type="button"
                            className="btn btn-light rounded-circle position-absolute"
                            style={{
                                top: "10px",
                                right: "18px",
                                width: "38px",
                                height: "38px",
                            }}
                            onClick={handleClose}
                        >
                            <i className="fa fa-times"></i>
                        </button>

                    </div>

                    {/* FORM */}
                    <form onSubmit={handleSubmit(onSubmit)}>

                        {/* BODY */}
                        <div className="modal-body p-4">

                            <div className="row g-4">

                                {/* ASSIGN EMPLOYEE */}
                                <div className="col-md-12">

                                    <label className="form-label fw-semibold">
                                        Assign Employee
                                        <span className="text-danger ms-1">*</span>
                                    </label>

                                    <Controller
                                        name="employee"
                                        control={control}
                                        rules={{
                                            required: "Please select atleast one employee",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                placeholder="Select Employee"
                                                options={employees}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={field.value || null}
                                                isClearable
                                                isSearchable
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                    setSelectedEmployee(selected);

                                                    if (selected?.value) {
                                                        getEmployeeLoad(selected.value);
                                                    } else {
                                                        setLoadData({});
                                                        setLoadPercentage({});
                                                    }
                                                }}
                                            />
                                        )}
                                    />

                                    {errors.employee && (
                                        <small className="text-danger fw-semibold">
                                            {errors.employee.message}
                                        </small>
                                    )}

                                </div>

                                {/* CURRENT LOAD */}
                                <div className="col-md-6">

                                    <div
                                        className="border rounded-4 p-4 h-100"
                                        style={{ background: "#f8fafc" }}
                                    >
                                        <p className="text-muted small mb-2">
                                            Current Lead Load
                                        </p>

                                        <h2 className="fw-bold text-primary mb-0">
                                            {loader
                                                ? "..."
                                                : `${Number(loadData?.pendingPercentage || 0)}%`}
                                        </h2>
                                    </div>

                                </div>

                                {/* ALLOWED LOAD */}
                                <div className="col-md-6">

                                    <div
                                        className="border rounded-4 p-4 h-100"
                                        style={{ background: "#f8fafc" }}
                                    >
                                        <p className="text-muted small mb-2">
                                            Allowed Lead Limit
                                        </p>

                                        <h2 className="fw-bold text-success mb-0">
                                            {loader
                                                ? "..."
                                                : `${Number(loadPercentage?.leadLoadPercentage || 0)}%`}
                                        </h2>
                                    </div>

                                </div>

                                {/* WARNING */}
                                {loadData?.pendingPercentage >
                                    loadPercentage?.leadLoadPercentage && (

                                        <div className="col-md-12">

                                            <div className="alert alert-danger rounded-4 border-0 mb-0">

                                                <i className="fa fa-warning me-2"></i>

                                                Employee is overloaded with{" "}
                                                <strong>
                                                    {loadData?.pendingPercentage}%
                                                </strong>{" "}
                                                pending leads.

                                            </div>

                                        </div>

                                    )}

                            </div>

                        </div>

                        {/* FOOTER */}
                        <div className="modal-footer border-0 px-4 pb-4">

                            <button
                                type="button"
                                className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                onClick={handleClose}
                            >
                                Close
                            </button>

                            <button
                                type="submit"
                                className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                disabled={submitLoader}
                            >
                                {submitLoader ? "Assigning..." : "Save"}
                            </button>

                        </div>

                    </form>

                </div>
            </div>
        </div>
    );
});

export default B2BAssignModal;